import React from "react";

interface SearchSectionProps {
  title: string;
  children: React.ReactNode;
}

export function SearchSection({ title, children }: SearchSectionProps) {
  return (
    <div>
      <h3 className="mb-2 px-2 font-mona text-2xs font-semibold text-neutral-700 uppercase tracking-wide">
        {title}
      </h3>
      <div className="space-y-1">{children}</div>
    </div>
  );
}
